import { ChevronLeft, ChevronRight } from "lucide-react";

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const shiftMonth = ({ year, month }, d) => {
  const m = month + d;
  return m < 1 ? { year: year - 1, month: 12 } : m > 12 ? { year: year + 1, month: 1 } : { year, month: m };
};

export const MonthPicker = ({ value, onChange, prefix = "report" }) => (
  <div className="flex items-center gap-2 print:hidden">
    <button data-testid={`${prefix}-prev-month-button`} onClick={() => onChange(shiftMonth(value, -1))} className="h-10 w-10 grid place-items-center rounded-lg border border-border hover:bg-secondary" aria-label="Previous month"><ChevronLeft className="h-4 w-4" /></button>
    <div className="flex gap-2">
      <select data-testid={`${prefix}-month-select`} value={value.month} onChange={(e) => onChange({ ...value, month: Number(e.target.value) })} className="h-10 rounded-lg border border-border bg-card px-3 text-sm font-semibold">
        {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
      </select>
      <input data-testid={`${prefix}-year-input`} type="number" value={value.year} onChange={(e) => onChange({ ...value, year: Number(e.target.value) || value.year })} className="h-10 w-24 rounded-lg border border-border bg-card px-3 text-sm font-mono font-semibold" />
    </div>
    <button data-testid={`${prefix}-next-month-button`} onClick={() => onChange(shiftMonth(value, 1))} className="h-10 w-10 grid place-items-center rounded-lg border border-border hover:bg-secondary" aria-label="Next month"><ChevronRight className="h-4 w-4" /></button>
  </div>
);
